import React, { FC } from 'react';

import styles from './styles.module.css';

export const SweepPaymentInfo: FC = () => {
  return (
    <div className={styles.container} data-testid="sweep-payment-info">
      <h4 className={styles.heading} data-testid="sweep-payment-info-heading">
        Sweep Payments
      </h4>
      <p className={styles.body} data-testid="sweep-payment-info-description">
        The total amount due today will be debited from your agency account per
        our sweep agreement.
      </p>
    </div>
  );
};
